import Media from 'react-media';
import { withTheme } from 'emotion-theming';

const HiddenOnSmallScreen = ({ children, theme }) => (
  <Media query={`(min-width: ${theme.breakpoints[0]})`}>{(matches) => (matches ? children : null)}</Media>
);

export default withTheme(HiddenOnSmallScreen);
